<template>
  <div class="longform-container">
    <Header :content="$ml.get('content').menu" :sectionIndex="index"/>
    <div class="longform-content" ref="scroller">
      <MenuLateral :menuLateral="menuLateral" :content="$ml.get('content').sections" :sectionIndex="index - 1" :offset="offset"/>
      <div ref="foreground">
        <section>
          <Landing :content="$ml.get('content').landing" @showMenu="toggleLateralMenu" :active="index <= 0"/>
        </section>
        <section v-for="(section, sectionIndex) in $ml.get('content').sections" :key="section.title" class="wim-section" :id="`wim-section-${sectionIndex === 0 ? '01' : sectionIndex}`">
          <div v-for="(element, index) in section.content" :key="index" class="wim-element">
            <CoverSection :content="element" v-if="element.type === 'cover'" :progress="offset"/>
            <Paragraph :content="element" v-if="element.type === 'paragraph'"/>
            <Quote :content="element" v-if="element.type === 'quote'"/>
            <FocusPreview :content="element" v-if="element.type === 'focus'"/>

            <ImageVideo :content="element" v-if="element.type === 'fullscreen' || (element.type === 'fullscreen-mobile' && $mq === 'mobile')"/>
            
            <Gallery :content="element" v-if="element.type === 'gallery'" :sectionIndex="sectionIndex" @videoAudioToggle="videoAudioToggle" :videoAudio="videoAudio"></Gallery>
            <GalleryMobile :galleryId="element.id" v-if="element.type === 'gallery-mobile'" />
          </div>
        </section>
      </div>
    </div>
    <WimFooter :content="$ml.get('content').footer"></WimFooter>
  </div>
</template>

<script>
import Scroller from '@sveltejs/svelte-scroller';

import Header from '../components/Header.vue';
import MenuLateral from '../components/MenuLateral.vue';
import Landing from '../components/Landing.vue';
import CoverSection from '../components/CoverSection.vue';
import Paragraph from '../components/Paragraph.vue';
import FocusPreview from '../components/FocusPreview.vue';
import ImageVideo from '../components/ImageVideo.vue';
import Quote from '../components/Quote.vue';
import Gallery from '../components/Gallery.vue';
import GalleryMobile from '../components/GalleryMobile.vue';
import WimFooter from '../components/WimFooter.vue';

export default {
  name: "LongForm",
  data(){
    return {
      menuLateral: false,
      index: 0,
      progress: 0,
      offset: 0,
      videoAudio: null
    }
  },
  beforeCreate() {
    if (this.$route.params.lang) {
      this.$ml.change(this.$route.params.lang);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.svelteScroller();
    });
  },
  components: {
    Header,
    Landing,
    Paragraph,
    CoverSection,
    MenuLateral,
    FocusPreview,
    ImageVideo,
    Quote,
    Gallery,
    GalleryMobile,
    WimFooter
  },
  methods: {
    videoAudioToggle(event) {
      this.videoAudio === event ? this.videoAudio = null : this.videoAudio = event
    },
    toggleLateralMenu(event) {
      this.menuLateral = event
    },
    svelteScroller() {
      // const background = this.$refs.background;
      const foreground = this.$refs.foreground;

      this.scroller = new Scroller({
        target: this.$refs.scroller,
        data: { top: 0, bottom: 1, threshold: 0.01 },
        // slots: { background, foreground },
        slots: { foreground }
      });

      window.addEventListener('scroll', () => {
        this.index = this.scroller._state.index;
        this.progress = this.scroller._state.progress;
        this.offset = this.scroller._state.offset;
      })
    }
  }
};
</script>

<style lang="scss">
@import "../assets/scss/colors.scss";
@import "../assets/scss/fonts.scss";
.longform-container {
  .longform-content {
    width: 100%;
    max-width: 1360px;
    margin: 0 auto;
  }
}
@media(max-width:768px){
  .longform-container {
    width: 100vw;
    margin: 0;
    padding:0;
  }
}
.flickity-viewport {
  transition: all .5s ease;
}
.flickity-page-dots{
      position: absolute;
      left: 0;
      bottom: 0;
      display: flex;
      flex-direction: row;
      justify-content: center;
      list-style: none;
      width: 100vw;
      padding: 0;
      margin: 0;
    }
    /* white circles */
    .flickity-page-dots .dot {
      width: 8px;
      height: 8px;
      opacity: 1;
      border-radius: 50%;
      background: transparent;
      border: 2px solid $beige;
      margin-right: 3%;
      &:last-of-type {
        margin-right: 0;
      }
    }
    /* fill-in selected dot */
    .flickity-page-dots .dot.is-selected {
      background: $beige;
    }
</style>
